import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import Heading from 'LuxKit/Typography/Heading'
import { FormattedMessage } from 'react-intl'
import { useCallback, type ReactNode } from 'react'

function TriplePointTakeoverHeroTitle() {
  const [tier] = useCurrentLoyaltyTier()
  const renderItalic = useCallback((chunks: ReactNode) => <i>{chunks}</i>, [])

  return <Heading variant="heading2" colour={`tier-${tier}-contrast`}>
    <FormattedMessage
      id="IWJ9IQpEnsYW66vMerdJ"
      defaultMessage="Your next trip just got <i>3x</i> better"
      description="Hero carousel heading for triple points takeover in the site takeover promotion"
      values={{ i: renderItalic }}
    />
  </Heading>
}

export default TriplePointTakeoverHeroTitle
